<template>
	
	<div style="text-align: center; padding: 30px;">

		<!-- <h6 class="text-secondary">  Copyright © 2025 Marsabit Weather Data </h6> -->
		
	</div>

</template>